import {
  localPathIpfsGateway,
  localSubDomainIpfsGateway,
  storachaIpfsGateway,
  w3sIpfsGateway,
} from '@rxap/config';
import { Environment } from './environment.interface';

export const environment: Environment = {
  name: 'production',
  production: true,
  app: 'portal',
  serviceWorker: true,
  fromDns: false,
  sentry: {
    enabled: true,
    debug: false,
    dsn: 'https://8b08a62197a0ab1f4244fc0c712b6941@o4508687415181312.ingest.de.sentry.io/4509332083703888',
  },
  dnsServers: [
    'https://dns.google/resolve',
    'https://cloudflare-dns.com/dns-query',
    `https://dns-resolve.${location.hostname.split('.').slice(-2).join('.')}`,
  ],
  ipfsGatewayServers: [
    w3sIpfsGateway,
    storachaIpfsGateway,
    localPathIpfsGateway,
    localSubDomainIpfsGateway,
  ],
};
